import { type ComposeType } from '../store/schema/ComposeType';
import { getComposeStore } from '..';

/**
 * This is getting consumed from other packages (eg. in AttachmentWellView
 * it's used to decide the styles if we are in compose or reading pane)
 */
const isFullComposeShown = (): boolean => {
    const viewState = getComposeStore().defaultViewState;

    return !!viewState && viewState.composeType === 'FullCompose';
};

export default isFullComposeShown;
